
import {
  defineComponent,
  SetupContext,
  toRefs,
  watch
} from "vue";
import NativeClient from "@/client/native-client";
import { BeaconLogInfo } from "@/types/common";
import { PAGE_ID } from "@/const/log-const";
  
export default defineComponent({
  name: "MypageMonthlyFoodsRankingQuestionDialog",
  props: {
    // ダイアログのアクティブ状態 (true: 活性、false: 非活性)
    isShowDialog: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("MypageMonthlyFoodsRankingQuestionDialog setup");

    // 表示／非表示を監視
    const { isShowDialog } = toRefs(props);
    watch(isShowDialog, () => {
      NativeClient.sendDebugLog("MypageMonthlyFoodsRankingQuestionDialog watch");
      if (isShowDialog.value) {
        NativeClient.sendDebugLog("MypageMonthlyFoodsRankingQuestionDialog watch log enable");
        const logInfo = new BeaconLogInfo(PAGE_ID.MYPAGE_USEDRANKING_DESCRIPTION, null, []);
        NativeClient.sendViewedLog(logInfo);
      }
    });

    const displayText = "■使い切り度の順位づけ\n食材管理タブで食材を「使い切った」「捨てた」と登録した回数をカウントし、使い切り度を算出しています。全ユーザーを100人としたときのあなたの順位を表示します。\n\n■使い切り食材ランキング\n食材管理タブで「使い切った」と登録した回数が多い食材順にランキング形式で表示しています。全国のユーザーの登録状況も確認できます。\n\n■捨てた食材ランキング\n食材管理タブで「捨てた」と登録した回数が多い食材順にランキング形式で表示しています。全国のユーザーの登録状況も確認できます。\n\n■「捨てた」「使い切った」の登録方法について\n以下の手順でタップしてください。\n食材管理タブ → メニュー→使い切りチェック";

    const closeAction = () => {
      NativeClient.sendDebugLog("MypageMonthlyFoodsRankingQuestionDialog closeAction");
      context.emit("click-close");
    };

    return {
      closeAction,
      displayText
    };
  }
});
